module.exports = __webpack_public_path__ + "img/T943.18381ce2.jpg";